import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import DashboardHeader from "../../../common/DasnboardHeader/DashboardHeader";
import { DispatchContext, StateContext } from "../../../store";
import { useNavigate } from "react-router";
import { loanApi } from "../../../services/LoanServices";
import Moment from "react-moment";
import DescriptionIcon from "@mui/icons-material/Description";

export default function LoanTable({ querySearch, museumId }) {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const { role } = useContext(StateContext);
  const [loans, setLoans] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [meta, setMeta] = useState({ total: 0 });
  const isAdminOrChief = role?.id === 1 || role?.id === 10;

  const asText = (value) => {
    if (value === null || value === undefined) return "-";
    if (typeof value === "object") {
      return value?.name || value?.code || value?.description || String(value?.id || "-");
    }
    const str = String(value);
    return str?.trim?.() ? str : "-";
  };

  useEffect(() => {
    fetchLoan();
  }, [querySearch, page, rowsPerPage, museumId]);

  const fetchLoan = () => {
    loanApi("get", null, { search: querySearch, page: page, per_page: rowsPerPage, museum_id: museumId }).then(
      (res) => {
        setLoans(res?.data);
        setMeta(res?.meta);
      }
    );
  };

  const handleLoanRequest = () => {
    navigate("/management/loan/loan-request");
  };

  const handleChangePage = (event, newPage) => {
    dispatch({ type: "IS_NOT_LOADING", payload: false });
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleDetail = (id) => {
    navigate(`/management/artifact-managements/${id}`);
  };

  return (
    <React.Fragment>
      {isAdminOrChief && (
        <div>
          <Box sx={{ mt: 5 }}>
            <Typography className={"museum-font"}>Loan</Typography>
          </Box>
          <Box>
            <DashboardHeader
              total={meta?.total}
              IconName={DescriptionIcon}
              iconColor={"#ff9653"}
              desc={"Total Loan Requests"}
            />
          </Box>
        </div>
      )}
      {role?.id === 2 && (
        <Box sx={{ textAlign: "right", mb: 2 }}>
          <Button onClick={() => handleLoanRequest()} variant={"contained"}>
            + Loan Request
          </Button>
        </Box>
      )}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: "#B3B3B3", width: 20 }}>Sl.no</TableCell>
              <TableCell sx={{ color: "#B3B3B3" }}>Accession No.</TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Object Name
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Object Type
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Agency Loaned To
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Location
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Duration
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Issue Date
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loans?.length > 0 &&
              loans?.map((loan, index) => (
                <TableRow key={index} hover onClick={() => handleDetail(loan?.id)}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{asText(loan?.accession_no)}</TableCell>
                  <TableCell align="left">{loan?.catalogue?.object_name}</TableCell>
                  <TableCell align="left">{asText(loan?.catalogue?.object_type || loan?.catalogue?.object_type_legacy)}</TableCell>
                  <TableCell align="left">{loan?.agency_loaned_to}</TableCell>
                  <TableCell align="left">{asText(loan?.catalogue?.location || loan?.catalogue?.location_legacy)}</TableCell>
                  <TableCell align="left">{loan?.duration}</TableCell>
                  <TableCell align="left">
                    <Moment format={"ll"}>{loan?.issue_date}</Moment>
                  </TableCell>
                  <TableCell align="left" className={"text-capitalize"}>
                    {loan?.state}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </React.Fragment>
  );
}
